import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import Base from '../base';
import { TransferUtils } from './transfer-utils';
var defaultOptions = {
  renderTo: null,
  insertUrl: null,
  deleteUrl: null,
  source: {
    title: null,
    url: null,
    columns: [],
    relateField: 'id'
  },
  target: {
    title: null,
    url: null,
    columns: [],
    relateField: 'id'
  }
};
export var Transfer = /*#__PURE__*/function (_Base) {
  _inherits(Transfer, _Base);

  var _super = _createSuper(Transfer);

  function Transfer(options) {
    var _this;

    _classCallCheck(this, Transfer);

    _this = _super.call(this, 'Transfer');

    _this.initialize(options, defaultOptions);

    TransferUtils.init(options, _assertThisInitialized(_this));
    return _this;
  }

  return Transfer;
}(Base);